import React, { useContext, useState } from 'react';
import { Button, DatePicker, Form, Input, Modal, Space, message } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import useService from '@/lib/hooks/useService';
import { ReservationContext } from '../UpdateProcessButtonWithModal';
import { UpdateReservationsContext } from '../TodayReservations';
import styles from './index.module.scss';
import type { CarServiceReservation } from '@/types/database/carService';

interface FormValuesType {
  actualCarTime: string;
  destination: string;
  estimatedArrivalTime: string;
}

dayjs.extend(advancedFormat);

const UpdateProcessToOnBoardButtonWithModal = () => {
  const { key: reservationId, reservationTime } =
    useContext(ReservationContext);
  const updateData = useContext(UpdateReservationsContext);

  const [form] = Form.useForm();

  const [, , carService] = useService<CarServiceReservation>({
    collectionName: 'carService',
  });

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const closeOnBoardFormModal = () => {
    form.resetFields();
    setIsOpenModal(false);
  };

  const handleFormSubmit = (values: FormValuesType) => {
    const { actualCarTime, destination, estimatedArrivalTime } = values;
    const newData = {
      actualCarTime: Number(dayjs(actualCarTime).format('x')),
      destination,
      estimatedArrivalTime: Number(dayjs(estimatedArrivalTime).format('x')),
    };
    carService
      .patch(reservationId, { ...newData, status: '已上車' })
      .then(() => {
        message.success('資料更新成功!');
        updateData();
      });
  };

  return (
    <>
      <Modal open={isOpenModal} onCancel={closeOnBoardFormModal} footer={false}>
        <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
          <Form.Item
            label="實際乘車時間"
            name="actualCarTime"
            rules={[{ required: true, message: '請選擇實際乘車時間' }]}
            initialValue={
              reservationTime
                ? moment(reservationTime).startOf('day')
                : moment().startOf('day')
            }
          >
            <DatePicker
              showTime={{ format: 'HH:mm' }}
              format="YYYY-MM-DD HH:mm"
              placeholder="請選擇實際乘車時間"
              inputReadOnly
            />
          </Form.Item>
          <Form.Item
            label="乘車目的地"
            name="destination"
            rules={[{ required: true, message: '請輸入乘車目的地' }]}
          >
            <Input placeholder="請輸入乘車目的地" />
          </Form.Item>
          <Form.Item
            label="預計抵達時間"
            name="estimatedArrivalTime"
            rules={[{ required: true, message: '請選擇預計抵達時間' }]}
            initialValue={
              reservationTime
                ? moment(reservationTime).startOf('day')
                : moment().startOf('day')
            }
          >
            <DatePicker
              showTime={{ format: 'HH:mm' }}
              format="YYYY-MM-DD HH:mm"
              placeholder="請選擇預計抵達時間"
              inputReadOnly
            />
          </Form.Item>
          <Form.Item>
            <Space className={styles.footerButtons}>
              <Button type="primary" onClick={closeOnBoardFormModal}>
                取消
              </Button>
              <Button htmlType="submit">確認</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
      <Button
        className={styles.stepButton}
        onClick={() => setIsOpenModal(true)}
      >
        新增進度
      </Button>
    </>
  );
};

export default UpdateProcessToOnBoardButtonWithModal;
